import DOMPurify from 'dompurify';
import { usePageExperienceContext } from '@/features/experiences/contexts/PageExperienceContext';
import { printVisibility } from '@/features/styles/lib/printStyles';
import { Text } from '@/ui';

export const DescriptionRead = () => {
  const { experience } = usePageExperienceContext();

  return (
    <Text
      className="ProseMirror"
      sx={printVisibility.hide()}
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(experience?.description ?? ''),
      }}
    />
  );
};
